import React from "react";
import ReactPlayer from "react-player";

export const Video = ({ src, ...props }) => (
  <ReactPlayer url={src} {...props} />
);
